import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

interface RewardTranslation {
  id: string;
  reward: Reward;
  title: string;
  lang: string;
  image: string;
}

function TableBodyRowContent({
  rewardTranslation,
  deletedList,
}: {
  rewardTranslation: RewardTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deleteRewardTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`rewards-translations/${id}`, token);
  });

  const removeRewardTranslation = () => {
    deleteRewardTranslation.mutate(rewardTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.rewardTranslationDeleted);
        queryClient.invalidateQueries(["getAllTranslations"]);
      },
    });
  };

  return (
    <TranslationRow
      id={rewardTranslation.id}
      deletedList={deletedList}
      withImage
      image={rewardTranslation?.image}
      sourceTitle={rewardTranslation?.reward?.title}
      translation={rewardTranslation?.title}
      lang={rewardTranslation?.lang}
      editTo={`/rewards-translations/update/${rewardTranslation.id}`}
      onDelete={removeRewardTranslation}
      isDeleting={deleteRewardTranslation.isLoading}
      modalMessage={general.fr.message.deleteRewardTranslationConfirm}
    />
  );
}

interface TableProps {
  rewardTranslations: RewardTranslation[];
  rewardTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function RewardsTranslationsTable({
  rewardTranslations,
  rewardTranslationsToBeDeleted,
}: TableProps) {
  if (!rewardTranslations?.length) {
    return (
      <div className="text-center py-4 text-muted">
        {general.fr.message.noRewardTranslations}
      </div>
    );
  }

  return (
    <TranslationTable sourceLabel="Bonus" translationLabel="Titre">
      {rewardTranslations.map((rewardTranslation) => (
        <TableBodyRowContent
          rewardTranslation={rewardTranslation}
          key={rewardTranslation.id}
          deletedList={rewardTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
